module.exports = __webpack_public_path__ + "d14514a81b70dfc5b90a608f41480a20.pdf";